import { take, catchError, map, switchMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { IEffect } from '../../../../../../shared/modules/dynamic-effects/effect.interface';
import {
  LOAD_SALES_AREA,
  LoadPointOfDeliverySalesArea,
  LoadPointOfDeliverySalesAreaComplete,
  LoadPointOfDeliverySalesAreaFail,
} from '../../../actions/point-of-delivery-actions/point-of-delivery.actions';
import { getSelectedBusinessLine, OrderBuilderState } from '../../../../../reducers';
import { IPointOfDeliverySalesAreasResponse } from '@cemex-core/cmx-api/models/point-of-delivery-sales-areas/point-of-delivery-sales-areas-response';
import { PointOfDeliverySalesAreasService } from '@cemex-core/cmx-api';
import { IShipmentLocation } from '@cemex-core/cmx-api/models/shipment-location/shipment-location';
import { IPointOfDeliverySalesAreasRequest } from '@cemex-core/cmx-api/models/point-of-delivery-sales-areas/point-of-delivery-sales-areas-request';
import { ProductType } from '@cemex-core/cmx-api/models/business-lines/product-type';

@Injectable()
export class PointOfDeliveryLoadSalesAreaEffects implements IEffect {
  pointOfDeliverySalesAreaLoad$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(LOAD_SALES_AREA),
      switchMap((payload: LoadPointOfDeliverySalesArea) => {
        return this.store
          .select(getSelectedBusinessLine)
          .pipe(take(1))
          .pipe(
            map((selectedBusinessLine: ProductType) => selectedBusinessLine.productTypeId),
            switchMap((businessLineId: number) => {
              return this.podSalesAreaService
                .getAddresses(this.preparePointOfDeliveryLoadSalesAreaRequest(payload.payload, businessLineId))
                .pipe(
                  map((podSalesAreaResponse: IPointOfDeliverySalesAreasResponse) => {
                    return new LoadPointOfDeliverySalesAreaComplete(podSalesAreaResponse.pointOfDeliverySalesAreas);
                  }),
                  catchError((error) => of(new LoadPointOfDeliverySalesAreaFail(error))),
                );
            }),
          );
      }),
    ),
  );

  constructor(
    private store: Store<OrderBuilderState>,
    private actions$: Actions,
    private podSalesAreaService: PointOfDeliverySalesAreasService,
  ) {}

  private preparePointOfDeliveryLoadSalesAreaRequest(
    selectedPointOfDelivery: IShipmentLocation,
    businessLine: number,
  ): IPointOfDeliverySalesAreasRequest {
    return {
      pointOfDeliveryId: selectedPointOfDelivery.shipmentLocationId,
      productLineId: businessLine,
    };
  }
}
